import React, { useState, useEffect, useContext } from 'react';
import { IonContent, IonPage, IonLoading, IonToast, IonHeader, IonToolbar, IonTitle, IonButtons, IonButton, IonIcon } from '@ionic/react';

import Firebase, { withFirebase } from '../services/Firebase';
import { AuthUserContext } from '../services/Session';
import Card from '../components/Card';

import './Diary.css'
import { qrCode } from 'ionicons/icons';

interface PageProps {
  firebase: Firebase,
}

const Flow: React.FC<PageProps> = ({ firebase }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error>();
  const [meals, setMeals] = useState<any[]>([]);
  const user = useContext(AuthUserContext);
  
  useEffect(() => {
    if(!user || ! user.groupIds) return;
    setLoading(true);
    const unsubscribe = firebase
    .meals()
    .where('groupIds', 'array-contains-any', user.groupIds)
    .limit(20)
    .orderBy('createdAt', 'desc')
    .onSnapshot((querySnapshot) => {
      const meals:any[] = [];
      querySnapshot.forEach((doc) => {
        const meal = {
          id: doc.id,
          createdAt: firebase.Timestamp.fromDate(new Date()),
          ...doc.data()
        };
        meal.createdAt = meal.createdAt.toDate();
        meals.push(meal);
      });
      setLoading(false);
      setMeals(meals);
    }, error => {
      setLoading(false);
      setError(error);
    })
    return () => {
      // Nettoyage de l'abonnement
      unsubscribe();
    };
  }, [firebase, user]);
  
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Flux de votre réseau</IonTitle>
          <IonButtons slot='end'>
            <IonButton routerLink='/home/flow/qrcode'>
              <IonIcon icon={qrCode} />
            </IonButton>
        </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonLoading isOpen={loading} />
        <IonToast
          isOpen={!!error}
          message={(error || { message: 'Oups, une erreure s\'produite...'}).message}
          duration={8000}
          color="danger"
        />
        {
          !meals || meals.length === 0
          ? <div className="diary_container">
            <img src='/assets/img/flow.jpg' alt='diary' className="diary_img"/>
            <div className="diary_text">Désolé, vous n'avez encore pas de repas partagés avec vous.</div>
          </div>
          : meals.map((meal: any) => (
            <Card meal={meal} key={meal.id} route='flow' />
          ))
        }
      </IonContent>
    </IonPage>
  );
};

export default withFirebase(Flow);
